import styled from 'styled-components'

export default styled.div`
  justify-content: center;
  display: grid;
  grid-auto-rows: 100px;
  grid-template-rows: 1fr 1fr;
  gap: 20px;
`
